import * as React from 'react';
import { Query, Mutation } from 'react-apollo';
import GET_ADMIN_INTEGRATION_ENABLED_STATE from 'admin/queries/getAdminIntegrationEnabledState.gql';
import SET_ADMIN_INTEGRATIONS_MUTATION from 'admin/mutations/setAdminIntegrations.gql';
import ToastActions from 'actions/ToastActions';

import AdminIntegration, {
  Props as AdminIntegrationProps,
} from 'admin/components/AdminIntegration';

import {
  upsertAdminToggledPartnerIntegration,
  upsertAdminToggledPartnerIntegrationVariables,
} from 'admin/mutations/__generated__/upsertAdminToggledPartnerIntegration';
import { getAdminIntegrationEnabledState } from 'admin/queries/__generated__/getAdminIntegrationEnabledState';

type ToggleIntegrationParamsType = {
  variables: {
    input: {
      isEnabled: boolean;
      orgUuid: string;
      providerKey: string;
    };
  };
};

const ToggleableAdminIntegration = ({
  isEnabled,
  integration,
  organizationUUID,
  ...props
}: AdminIntegrationProps) => (
  <Mutation<upsertAdminToggledPartnerIntegration, upsertAdminToggledPartnerIntegrationVariables>
    mutation={SET_ADMIN_INTEGRATIONS_MUTATION}
    onCompleted={() => ToastActions.showSuccessToast('Saved')}
    onError={error => ToastActions.showErrorToast(error.message)}
    refetchQueries={[
      {
        query: GET_ADMIN_INTEGRATION_ENABLED_STATE,
        variables: { providerKey: integration.providerKey, organizationUUID },
      },
    ]}>
    {(toggleIntegration: (params: ToggleIntegrationParamsType) => void) => (
      <AdminIntegration
        {...{ integration, organizationUUID, isEnabled, ...props }}
        isToggleable
        toggleClickHandler={() =>
          toggleIntegration({
            variables: {
              input: {
                orgUuid: organizationUUID,
                isEnabled: !isEnabled,
                providerKey: integration.providerKey,
              },
            },
          })
        }
      />
    )}
  </Mutation>
);

const AdminRemindPlanIntegrationContainer = (props: AdminIntegrationProps) => (
  <Query<getAdminIntegrationEnabledState>
    query={GET_ADMIN_INTEGRATION_ENABLED_STATE}
    variables={{
      organizationUUID: props.organizationUUID,
      providerKey: props.integration.providerKey,
    }}>
    {({ loading, error, data: { adminToggledPartnerIntegration: state } = {} }) => {
      if (loading || error || !state) return null;

      return state.isEnabledForParent ? (
        <AdminIntegration {...props} isToggleable hasDistrictOverride />
      ) : (
        <ToggleableAdminIntegration {...props} isEnabled={!!state.isEnabled} />
      );
    }}
  </Query>
);

export default AdminRemindPlanIntegrationContainer;
